import Loader from "@builder/components/app/Loading/Loader";
import InfiniteScroll from "../../../InfiniteScroll";
import SimpleCheckbox from "../../../SimpleCheckbox";

interface CheckboxOptionProps {
    options: string[];
    setCheckedOptions: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
    checkedOptions: Record<string, boolean>;
    handleIntersect: () => void;
    hasMore: boolean;
    isLoading: boolean;
}

const CheckboxOptions = ({ options, setCheckedOptions, checkedOptions, hasMore, handleIntersect, isLoading }: CheckboxOptionProps) => {
    const handleCheckboxChange = (option: string, isChecked: boolean) => {
        setCheckedOptions((prevState) => {
            let newState;
            if (isChecked) {
                newState = { ...prevState, [option]: true };
            } else {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { [option]: _, ...rest } = prevState;
                newState = rest;
            }
            return newState;
        });
    };

    return (
        <InfiniteScroll hasMore={hasMore} onIntersect={handleIntersect}>
            {options && options.map((option, index) => (
                <div className="select-input-option-con" key={index}>
                    <SimpleCheckbox
                        value={option}
                        label={option.charAt(0).toUpperCase() + option.slice(1)}
                        callback={handleCheckboxChange}
                        checked={checkedOptions[option] || false}
                    />
                </div>
            ))}
            {options.length === 0 && <div className="select-input-option-con empty">No matches found.</div>}
            {isLoading && options && options.length > 0 ? (
                <div className="select-input-option-con empty loader">
                    <Loader width="28" height="28" />
                </div>
            ) : null}
        </InfiniteScroll>
    );
};

export default CheckboxOptions;
